import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 引入 Vant 移动端框架
import Vant from 'vant'
import 'vant/lib/index.css'
// 引入全局样式（放在Vant样式之后，确保主题变量覆盖Vant默认样式）
import './assets/css/global.css'
// 管理系统通用页面样式
import './assets/css/page.css'
// 引入 Vuex store
import store from './store'
// 引入路由
import router from './router'
import { isLogin } from './api/public.js'
import * as echarts from 'echarts';

Vue.use(ElementUI)
Vue.use(Vant)
Vue.prototype.$echarts = echarts;

// 路由守卫：未登录一律跳登录页（mock 模式下登录走本地账号校验，见 src/mock/login.js）
router.beforeEach((to, from, next) => {
  // 1. 登录页：已登录则回主页，未登录放行
  if (to.path === '/login') {
    if (localStorage.getItem('token') && store.getters.getIsLogin) {
      next('/home')
    } else {
      next()
    }
    return
  }

  // 2. 其他页面：校验登录态（token + 用户信息，刷新后由 initUserInfo 从本地恢复）
  const token = localStorage.getItem('token')
  if (!token) {
    next('/login')
    return
  }

  // 2.1 调 /admin/is-login 自检 token 是否有效（过期/无效则清登录态回登录页）
  return isLogin().then(res => {
    const valid = res && res.code === 200 && res.data && res.data.loggedIn
    if (!valid) {
      localStorage.removeItem('token')
      store.dispatch('logout')
      next('/login')
      return
    }
    // token 有效但本地未恢复登录态（极端情况），用返回的用户信息重建
    if (!store.getters.getIsLogin) {
      const u = (res.data && res.data.user) || {}
      store.commit('setUserInfo', {
        name: u.username || '管理员',
        avatar: '',
        phone: '',
        is_super: u.is_super,
        role: u.is_super === 1 ? '超级管理员' : '管理员',
        permissions: []
      })
    }

    // 3. 已登录：首次进入补装权限列表
    if (store.getters.getPermissionList.length === 0) {
      store.dispatch('loadPermissionList').then(() => {
        // 权限列表加载完成后，检查当前路由权限
        checkPermission(to, next)
      })
    } else {
      // 权限列表已加载，直接检查当前路由权限
      checkPermission(to, next)
    }
  }).catch(() => {
    localStorage.removeItem('token')
    store.dispatch('logout')
    next('/login')
  })
})

// 检查路由权限
function checkPermission(to, next) {
  // 路由白名单，无需权限验证的路由
  const whiteList = ['/home']
  
  if (whiteList.includes(to.path)) {
    next()
    return
  }
  
  // 获取当前用户的菜单列表
  const menuList = store.state.menuList
  
  // 检查当前路由是否在用户的菜单列表中
  // const hasMenuPermission = checkRouteInMenuList(to.path, menuList)
  const hasMenuPermission = true
  
  // 检查当前路由是否在用户的权限列表中
  // const hasPermission = store.getters.hasPermission(to.name)
  const hasPermission = true
  
  if (hasMenuPermission || hasPermission) {
    next()
  } else {
    // 没有权限，跳转到首页或权限不足页面
    Vue.prototype.$message.error('您没有访问该页面的权限')
    next('/home')
  }
}

// 递归检查路由是否在菜单列表中
function checkRouteInMenuList(routePath, menuList) {
  for (const menu of menuList) {
    // 检查当前菜单的path是否匹配
    if (menu.path === routePath) {
      return true
    }
    
    // 递归检查子菜单
    if (menu.children && menu.children.length > 0) {
      if (checkRouteInMenuList(routePath, menu.children)) {
        return true
      }
    }
  }
  return false
}

// 初始化用户信息
store.dispatch('initUserInfo')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')